import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root'})
export class MessageService {

    public showMessage: boolean;
    
    getShowMessage () {
        return this.showMessage;
    }

    setShowMessage (show) {
        this.showMessage = show;
    }
}